// ui
import { Icon, IconProps } from "@chakra-ui/react";

export const PauseIcon = (props: IconProps) => (
  <Icon viewBox="0 0 16 17" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.90684 0.255737H3.40684C4.73232 0.255737 5.80684 1.33025 5.80684 2.65574V13.6557C5.80684 14.9812 4.73232 16.0557 3.40684 16.0557H2.90684C1.58135 16.0557 0.506836 14.9812 0.506836 13.6557V2.65574C0.506836 1.33025 1.58135 0.255737 2.90684 0.255737ZM2.90684 1.65574C2.35455 1.65574 1.90684 2.10345 1.90684 2.65574V13.6557C1.90684 14.208 2.35455 14.6557 2.90684 14.6557H3.40684C3.95912 14.6557 4.40684 14.208 4.40684 13.6557V2.65574C4.40684 2.10345 3.95912 1.65574 3.40684 1.65574H2.90684Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.9068 0.255737H13.4068C14.7323 0.255737 15.8068 1.33025 15.8068 2.65574V13.6557C15.8068 14.9812 14.7323 16.0557 13.4068 16.0557H12.9068C11.5814 16.0557 10.5068 14.9812 10.5068 13.6557V2.65574C10.5068 1.33025 11.5814 0.255737 12.9068 0.255737ZM12.9068 1.65574C12.3546 1.65574 11.9068 2.10345 11.9068 2.65574V13.6557C11.9068 14.208 12.3546 14.6557 12.9068 14.6557H13.4068C13.9591 14.6557 14.4068 14.208 14.4068 13.6557V2.65574C14.4068 2.10345 13.9591 1.65574 13.4068 1.65574H12.9068Z"
      fill="currentColor"
    />
  </Icon>
);
